const AI = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">AI</h1>
        <p className="text-muted-foreground">
          Configure AI analysis over extracted datasets, charts, and generated insights.
        </p>
      </div>
      <div className="card-elevated p-5">
        <p className="text-sm text-muted-foreground">
          TODO: Add AI assistant tools for correlation, narrative summaries, and hypothesis testing.
        </p>
      </div>
    </div>
  );
};

export default AI;
